// extracted by mini-css-extract-plugin
export default {"cajon_formacion":"formacion_cajon_formacion__Ly8vG","titulo":"formacion_titulo__noNdK"};